import React from 'react';
import PropTypes from 'prop-types';
import { SwitchToggle, Typography, SpacerVertical, IconInformation } from '@klarna/bubble-ui';

import { withTooltip } from 'moet-core';
import { generateCyElemId } from 'moet-test-utils/cypress/utils';

const SwitchToggleField = ({
  label,
  idForTestSuite = undefined,
  tooltipIcon = IconInformation,
  tooltipText,
  tooltipIconLabel = tooltipText,
  tabIndex = 0,
  ...props
}) => (
  <>
    <SpacerVertical small />
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'nowrap',
        justifyContent: 'space-between',
        width: '100%',
        zIndex: 100,
      }}
    >
      <SwitchToggle tabIndex={tabIndex} {...generateCyElemId(idForTestSuite, window)} {...props}>
        <Typography textToken="text-style/text/super-paragraphs/body/regular">{label}</Typography>
      </SwitchToggle>
    </div>
    <SpacerVertical small />
  </>
);

SwitchToggleField.propTypes = {
  label: PropTypes.string.isRequired,
  idForTestSuite: PropTypes.string,
  tabIndex: PropTypes.number,
  tooltipIcon: PropTypes.elementType,
  tooltipIconLabel: PropTypes.string,
  tooltipText: PropTypes.string,
};

export default withTooltip(SwitchToggleField, {
  tooltipBottomOverride: '15px',
  tooltipWidth: '100%',
});
